<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button @click="openEditContentPopup" class="bg_l_green">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewContent") }}
            </vs-button>
          </div>
        </div>
        <edit-content-popup
          :show="editContentPopup"
          :model-to-edit="modelToEdit"
          @close="closeEditContentPopup"
          @finish="onCreateContentSuccess"
        ></edit-content-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Title') },
                { title: $t('Subtitle') },
                { title: $t('CreateOn') },
                { title: $t('DisplayOrder') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.title }}
                </td>
                <td style="width: 30%">
                  {{ row.subTitle }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 10%">
                  {{ row.priority }}
                </td>
                <td style="width: 25%">
                  <div
                    class="w-full h-full flex justify-center items-center gap-2"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="flex gap-2 p-1 px-2"
                      @click="onEditContent(row)"
                      >{{ $t("Edit") }}</vs-button
                    >
                    <router-link
                      :to="{
                        path: '/contents/' + row.id,
                        query: { breadcrumbName: row.title },
                      }"
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="flex gap-2 p-1 px-2"
                        >{{ $t("Items") }}</vs-button
                      >
                    </router-link>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteContent(row.id)"
                      class="d-inline"
                    ></vs-button>
                  </div>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import EditContentPopup from "./EditContentPopup.vue";
export default {
  name: "ContentManagement_Contents_Index",

  components: {
    EditContentPopup,
    DataGrid,
  },
  data() {
    return {
      editContentPopup: false,
      gridDataSource: {
        type: "app",
        service: "CMS/api/ContentsQuery/withoutItems",
      },
      gridSearchData: {
        keyword: "",
      },
      modelToEdit: {},
    };
  },
  methods: {
    ...mapActions({
      removeContent: "contentType/deleteContent",
    }),
    onEditContent(content) {
      this.modelToEdit = content;
      this.openEditContentPopup();
    },
    //Open Modal In Create Mode
    openEditContentPopup() {
      this.editContentPopup = true;
    },
    //Delete Method
    deleteContent(id) {
      const payload = { id };
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeContent(payload).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.renderGrid();
          });
        }
      });
    },
    closeEditContentPopup() {
      this.editContentPopup = false;
      this.modelToEdit = {};
    },
    onCreateContentSuccess() {
      this.closeEditContentPopup();
      this.$refs.grid.renderGrid();
    },
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 400);
    },
  },
};
</script>

<style scoped></style>
